export interface Reconcilable {
  id: string
  description: string
  originalAmountCents: number
  updatedAmountCents: number
  currency: string
}
export interface ReconciliationItem {
  id: string
  reconciliationId?: string
  description: string
  creditCentsToReconcile: number
  debitCentsToReconcile: number
  currency: string
  date: string
}

export type ReconciliationSource = {
  id: string
  description: string
  creditCentsToReconcile: number
  debitCentsToReconcile: number
  currency: string
  date: string
  reconciliationStatus: ReconciliationStatusEnum
  type: SourceReconciliationType
}

// eslint-disable-next-line factorial/no-unhealthy-enums
export enum ReconciliationStatusEnum {
  None = 'none',
  Full = 'full',
  Partial = 'partial',
}

export type SourceReconciliationType = 'bankAccount' | 'financialDocument'
